export default __webpack_public_path__ + "static/media/about_us_mobile.148b1428.png";